// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-about-mycolor--pc[data-v-011e3c4c]{background:#fff;color:#000;font-size:14px;justify-content:center;margin-top:20px}", ""]);
// Exports
module.exports = exports;
